<template>
	<div tabindex="0" class="hide-outline">
		<main class="main-view no-top-panel">
			<div class="title" v-if="showTopPanel">Ny brist</div>
			<div class="top-box" v-if="item && item.id && showTopPanel">
				<div class="row" :style="mobile">
					<div class="field name">
						<label class="label">Inventarie</label>
						<div class="control">
							<textarea
								v-model="item.name"
								class="textarea no-resize"
								rows="2"
								placeholder="Inventariens namn"
								disabled
							/>
						</div>
					</div>
					<div class="field description">
						<label class="label">Beskrivning</label>
						<div class="control">
							<textarea
								v-model="item.description"
								class="textarea no-resize"
								rows="2"
								placeholder="Inventariens beskrivning"
								disabled
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="top-box" v-if="item && showTopPanel">
				<div class="row" :style="mobile">
					<div class="field">
						<label class="label">Brist</label>
						<div class="control">
							<input
								v-model="flaw.name"
								class="input"
								placeholder="Bristens namn"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">Beskrivning</label>
						<div class="control">
							<input
								v-model="flaw.description"
								class="input"
								placeholder="Bristens beskrivning"
							/>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="field">
						<label class="label">Åtgärd</label>
						<div class="control">
							<input
								v-model="flaw.measure"
								class="input"
								placeholder="Åtgärd"
							/>
						</div>
					</div>
					<div class="checks">
						<div class="field check" :class="{ mobile: isMobile }">
							<label class="label"> Åtgärdad</label>
							<div class="control">
								<switchButton v-model="isFixed" />
							</div>
						</div>
						<div class="field check" :class="{ mobile: isMobile }">
							<label class="label"> Åtgärda alla</label>
							<div class="control">
								<switchButton v-model="fixAll" />
							</div>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="field">
						<label class="label">Ansvarig</label>
						<div class="control">
							<input
								v-model="roundData.roleName"
								class="input"
								placeholder="Ansvarig för ronden"
								disabled
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">Utförare</label>
						<div class="control">
							<input
								v-model="getUser.email"
								class="input"
								placeholder="Rondens utförare"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="row" :style="mobile">
					<div class="picture-upload" :class="{ mobile: isMobile }">
						<img v-if="imgSrc" class="image-preview" :src="imgSrc" />

						<div class="field picture">
							<div class="file has-name is-fullwidth is-dark">
								<label class="file-label">
									<input
										class="file-input"
										type="file"
										name="resume"
										accept="image/*"
										@change="uploadImage"
									/>
									<span class="file-cta">
										<span class="file-icon">
											<i class="fas fa-upload"></i>
										</span>
										<span class="file-label">
											Välj en bild…
										</span>
									</span>
									<span class="file-name">
										{{ imageName }}
									</span>
								</label>
							</div>
						</div>
					</div>
					<div class="buttons" :class="{ mobile: isMobile }">
						<button class="button is-info" @click="addFlaw" :disabled="disable">
							<span class="icon is-white"><i class="fas fa-plus"/></span
							><span>Lägg till</span>
						</button>
						<button class="button is-dark" @click="navigate">
							<span class="icon is-white"><i class="fas fa-backward"/></span
							><span>Tillbaka</span>
						</button>
						
						<button class="button" @click="continueWithFlaw" v-if="showIgnoreButton">Ignorera</button>
					</div>
				</div>
			</div>
			<div class="list-header">
				<div class="title" style="margin-top: 30px; margin-bottom: 10px;">
					{{
						item.name && showTopPanel ? `Alla brister - ${item.name}` : "Brist"
					}}
				</div>
				<button class="button is-dark" @click="navigate" v-if="!showTopPanel">
					<span class="icon is-white"><i class="fas fa-backward"/></span
					><span>Tillbaka</span>
				</button>
			</div>
			<div class="panel-list-header">
				<div class="panel-header-item">Brist</div>
				<div class="panel-header-item">Beskrivning</div>
				<div class="panel-header-item fixed">Åtgärdad</div>
			</div>
			<div
				class="panel-list no-hover"
				v-for="flaw in comFlaws"
				:class="isDone(flaw)"
				:key="flaw.id"
				@click="openModal(flaw)"
			>
				<div class="panel-list-item">{{ flaw.name }}</div>
				<div class="panel-list-item">
					{{ flaw.description }}
				</div>
				<div class="panel-list-item fixed">
					<i
						class="far"
						:class="flaw.done ? 'fa-check-square' : 'fa-square'"
					></i>
				</div>
			</div>
			<div class="panel-list no-hover" v-if="comFlaws.length == 0">
				<p class="panel-list-item">Inga brister</p>
			</div>
			<FlawModal
				v-if="showModal"
				:flaw="selectedFlaw"
				@cancel="toggleModal"
				@setFixed="setFixed"
			/>
		</main>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import switchButton from '@/components/switchButton';
import FlawModal from './modals/FlawModal';
export default {
	components: {
		switchButton,
		FlawModal
	},
	data: () => ({
		selectedTab: 0,
		roundData: null,
		loaded: false,
		item: {
			fireProtection: {}
		},
		flaw: {
			name: '',
			description: '',
			done: null,
			performer: '',
			responsible: '',
			fileId: null
		},
		fileName: null,
		isFixed: false,
		imgSrc: null,
		fixAll: false,
		selectedFlaw: null,
		showModal: false,
		newFlaw: []
	}),
	computed: {
		...mapGetters('roundHistoryStore', ['roundHistory', 'activeRound']),
		...mapGetters('roundStore', ['round']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getUser']),
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		},
		comFlaws() {
			let list = [];

			if (this.item.flaws) {
				list = list.concat(this.item.flaws);
			}

			list = list.concat(this.newFlaw);

			return list.reverse();
		},
		disable() {
			return !this.flaw.name ? true : false;
		},
		imageName() {
			return this.fileName || 'Ingen bild vald';
		},
		showTopPanel() {
			return !this.item.flawScale && !this.newFlaw.length;
		},
		showIgnoreButton() {
			if (this.comFlaws.length > 0 && this.comFlaws.some(x => x.done === null))
				return true;

			return false;
		}
	},
	watch: {
		round: {
			handler(to) {
				//Make sure we're loaded, or we might wipe the data
				if (this.loaded) {
					this.roundData = to;
					this.SET_ACTIVEROUND(this.roundData);
				}
			},
			deep: true
		}
	},
	methods: {
		...mapActions('roundStore', ['setRound']),
		...mapMutations('roundHistoryStore', ['SET_ACTIVEROUND']),
		isDone(flaw) {
			return flaw.done ? 'done' : 'not-done';
		},
		addFlaw() {
			if (this.item.id) {
				this.flaw.mapItemId = this.item.mapItemId;
				this.flaw.roundHistoryInfoId = this.roundData.infos[
					this.roundData.currentInfo
				].id;
			} else {
				this.flaw.roundHistoryInfoId = this.roundData.infos[
					this.roundData.currentInfo
				].id;
				this.flaw.flawPositionX = this.roundData.position
					? parseInt(this.roundData.position[0] + 15 || 30)
					: 30;
				this.flaw.flawPositionY = this.roundData.position
					? parseInt(1000 - this.roundData.position[1] - 15 || 30)
					: 30;
				this.flaw.flawScale = 1;
			}

			this.flaw.performer = this.getUser.email;
			this.flaw.responsible = this.roundData.roleId;

			if (this.isFixed) {
				this.flaw.done = this.setDate();
				this.flaw.doneBy = this.getUser.email;
			}

			if (this.fixAll) {
				this.comFlaws.forEach(flaw => {
					if (!flaw.done) {
						flaw.done = this.setDate();
						flaw.doneBy = this.getUser.email;
						flaw.measure = flaw.measure || this.flaw.measure;
					}
				});
			}

			this.item.controlled = this.setDate();
			this.item.userName = this.getUser.email;

			if (this.item && this.item.id) {
				this.item.flaws.push(this.flaw);
			} else {
				if (!this.roundData.infos[this.roundData.currentInfo].flaws) {
					this.roundData.infos[this.roundData.currentInfo].flaws = [];
				}

				this.newFlaw.push(this.flaw);
				this.roundData.infos[this.roundData.currentInfo].flaws.push(this.flaw);
			}

			const info = this.roundData.infos[this.roundData.currentInfo];

			if (this.item.flawScale) {
				info.flaws[
					this.roundData.flawIndex - info.roundHistoryItems.length
				] = this.item;
			} else {
				info.roundHistoryItems[this.roundData.flawIndex] = this.item;
			}

			this.SET_ACTIVEROUND(this.roundData);
			this.$emit('flaw-added', this.item.id ? this.item : this.flaw);

			this.flaw = {
				name: '',
				description: '',
				done: null,
				mapItemId: '',
				performer: '',
				responsible: '',
				fileId: null,
				file: null
			};
			this.isFixed = false;
			this.fixAll = false;
			this.imgSrc = null;
			this.fileName = null;
		},
		navigate() {
			if (this.$route.name === 'RoundView') {
				this.$emit('goBack');
			} else {
				this.$router.push({
					name: 'RoundView',
					params: { roundId: this.roundData.id }
				});
			}
		},
		continueWithFlaw() {
			this.$emit('continueWithoutAdding', this.item);
		},
		setFixed(measure) {
			if (measure || measure === '') {
				let flawIndex = -1;
				let loneFlaw = false;

				if (
					this.roundData.flawIndex > this.roundData.infos[this.roundData.currentInfo].roundHistoryItems.length -1
				) {
					flawIndex = this.roundData.infos[
						this.roundData.currentInfo
					].flaws.findIndex(flaw => flaw.id === this.selectedFlaw.id);
					loneFlaw = true;
				} else {
					flawIndex = this.roundData.infos[
						this.roundData.currentInfo
					].roundHistoryItems[this.roundData.flawIndex].flaws.findIndex(
						flaw => flaw.id === this.selectedFlaw.id
					);
				}

				this.selectedFlaw.done = this.setDate();
				this.selectedFlaw.doneBy = this.getUser.email;
				this.selectedFlaw.measure = measure;
				this.item.controlled = this.setDate();

				if (loneFlaw) {
					this.roundData.infos[this.roundData.currentInfo].flaws[
						flawIndex
					] = this.selectedFlaw;
				} else {
					this.roundData.infos[this.roundData.currentInfo].roundHistoryItems[
						this.roundData.flawIndex
					].flaws[flawIndex] = this.selectedFlaw;
				}

				this.SET_ACTIVEROUND(this.roundData);
				this.toggleModal();
				this.$emit('flaw-fixed', this.selectedFlaw);
			}
		},
		async uploadImage(event) {
			this.fileName = event.target.files[0].name;
			let reader = new FileReader();
			reader.onload = event => {
				this.imgSrc = event.target.result;
				this.flaw.file = event.target.result;
			};
			await reader.readAsDataURL(event.target.files[0]);
		},
		openModal(flaw) {
			if (!flaw.done) {
				this.selectedFlaw = flaw;
				this.showModal = true;
			}
		},
		toggleModal() {
			this.showModal = !this.showModal;
		},
		setDate() {
			let date = new Date();
			date.setHours(date.getHours() - date.getTimezoneOffset() / 60);

			return date;
		}
	},
	created() {
		var viewport = document.querySelector('meta[name="viewport"]');

		if (viewport) {
			viewport.content = 'initial-scale=1';
			viewport.content = `width=${window.innerWidth}`;
		}

		if (this.roundHistory) {
			this.roundData = { ...this.activeRound };
			this.setRound(this.roundData);

			if (this.roundData.flawIndex !== -1) {
				const info = this.roundData.infos[this.roundData.currentInfo];

				if (this.roundData.flawIndex > info.roundHistoryItems.length - 1) {
					this.item = info.flaws[this.roundData.flawIndex - info.roundHistoryItems.length];
					this.newFlaw = [this.item];
				} else {
					this.item = info.roundHistoryItems[this.roundData.flawIndex];
				}
			}

			this.$nextTick(() => {
				this.loaded = true;
			});
		}
	},
	// eslint-disable-next-line no-empty-pattern
	beforeRouteLeave({}, {}, next) {
		const info = this.roundData.infos[this.roundData.currentInfo];

		if (this.item.flawScale) {
			info.flaws[
				this.roundData.flawIndex - info.roundHistoryItems.length
			] = this.item;
		} else {
			info.roundHistoryItems[this.roundData.flawIndex] = this.item;
		}

		this.SET_ACTIVEROUND(this.roundData);
		next();
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
    &:not(:first-child) {
      margin-top: 12px;
    }
    .checks {
      flex: 1;
      display: flex;
      align-items: center;
      .field.check {
        &:not(.mobile) {
          .label {
            margin-bottom: 0;
          }
          margin-top: -0.5rem;
        }

        max-width: 80px;
        margin-bottom: 0;
      }
    }
  }
  .picture-upload {
    display: block;
    max-width: 400px;
    &.mobile {
      margin-left: auto;
      margin-right: 10px;
    }
    .file-name {
      background-color: white;
    }
  }
  .field {
    position: relative;
    flex: 1;
    &.name {
      flex: 1;
    }
    &.description {
      flex: 2;
    }
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
    /* &.check {
      display: flex;
      align-items: center;
      .checkbox {
        margin-top: 12px;
      }
      &.is-mobile .checkbox {
        margin-top: 0;
      }
    } */
    &.picture {
      margin-right: 0;
    }
  }
  .textarea,
  .input {
    background: white;
    border-radius: 2px;
  }
  .buttons {
    margin: 0;
    margin-left: auto;
    margin-right: 10px;
    &.mobile {
      margin-top: 0.75rem;
      justify-content: flex-end;
    }
    .button {
      border-radius: 2px;
      width: 110px;
    }
    &:not(.mobile) .button {
      align-self: flex-end;
    }
  }
}
.tabs.is-boxed {
  margin-bottom: 0;
}
.panel-list {
  &.done {
    background-color: #cdebcd;
    &:nth-child(odd) {
      background-color: #c3e0c3;
    }
  }
  &.not-done {
    background-color: #f0cbcb;
    cursor: pointer;
    &:nth-child(odd) {
      background-color: #e9b9b9;
    }
  }
}
.panel-header-item.fixed {
  width: 76px;
}
.panel-list-item.fixed {
  width: 90px;
  margin-right: 20px;
  text-align: center;
  &.clickable {
    pointer-events: all;
    cursor: pointer;
  }
  i {
    color: black;
  }
}
.image-preview {
  padding-left: 10px;
  margin-bottom: -6px;
}
.list-header {
  display: flex;
  margin-bottom: 0.5rem;
  justify-content: space-between;
  .button {
    border-radius: 2px;
    width: 110px;
    margin-top: 1.7rem;
  }
}
</style>
